module.exports = __webpack_public_path__ + "img/Bg.ff682eda.svg";